const partnerNames = [
  '星辰影视', '极光在线', '飞流影院', '星河视频',
  '海豚剧场', '彩虹影视', '云帆播放', '光影世界',
  '蓝鲸视频', '悦动视界',
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-base">
                云
              </span>
              <span className="text-lg font-bold text-background-100">白云视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              白云视频提供苹果视频、榴莲视频同款手机看片体验，免费影视app在线视频平台，随时随地高清视频播放。海量资源每日更新，流畅不卡顿。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">分类索引</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">热度榜单</a>
              <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">最新动态</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">热门推荐</h4>
            <div className="flex flex-col gap-2">
              <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">热门话题</a>
              <a href="#media" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">精彩视频</a>
              <a href="#features" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">平台特色</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">常见问答</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2">
              <a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">在线咨询</a>
              <a href="#app" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">App下载</a>
              <a href="#about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-background-800/50">
          <h4 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h4>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {partnerNames.map((name) => (
              <span key={name} className="text-sm text-background-500 whitespace-nowrap">{name}</span>
            ))}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 白云视频 BaiYunShipin. 本站内容仅供展示，不提供实际播放服务。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 whitespace-nowrap">白云视频</span>
            <span className="text-xs text-background-500 whitespace-nowrap">苹果视频同款</span>
            <span className="text-xs text-background-500 whitespace-nowrap">榴莲视频体验</span>
          </div>
        </div>
      </div>
    </footer>
  );
}